import i18n from 'i18next'
import Markdown from 'markdown-to-jsx'
import React, { useEffect, useState } from 'react'

import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import FavoriteIcon from '@mui/icons-material/Favorite'
import Pagination from '@mui/material/Pagination'
import Typography from '@mui/material/Typography'
import makeStyles from '@mui/styles/makeStyles'
import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import k from './../../i18n/keys'
import { useBackend } from '@/src/providers/BackendProvider'
import styles from '@/pages/scss/Foundersletter.module.scss'
import Trustpilot from '@/src/components/Trustpilot'

const useStyles = makeStyles({
  paginationButton: {
    '& .MuiPaginationItem-page': {
      backgroundColor: '#F1F1F1'
    },

    '& .Mui-selected': {
      backgroundColor: '#1A1A1A',
      color: '#ffffff'
    },

    '& .MuiPaginationItem-root': {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '-0.24px'
    }
  },

  buttonStyle: {
    width: 'fit-content',
    // border: '1px #1A1A1A solid',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    border: '1px solid #979797',
    padding: '4px 12px',
    cursor: 'pointer',
    '& > *': {
      color: '#979797'
    }
  },

  buttonText: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '-0.5px'
  },

  buttonStyleSelected: {
    width: 'fit-content',
    // border: '1px #1A1A1A solid',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    border: '1px solid #1A1A1A',
    padding: '4px 12px',
    cursor: 'pointer',
    color: '#1A1A1A',
    textWrap: 'nowrap'
  }
})

const Forum = ({ data }) => {
  const theme = useTheme()
  const classes = useStyles(theme)
  const abMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const [pageIndex, setPageIndex] = useState(1)
  const { patchLike } = useBackend()
  const curYear = new Date().getFullYear()
  const curMonth = new Date().getMonth() + 1 // start with 0
  const curDay = new Date().getDate()
  const [timeInterval, setTimeInterval] = useState(false)
  const [show, setShow] = React.useState(false)
  const [showContent, setShowContent] = useState(data.results)
  const [Review, setReview] = useState()
  const [Forum, setForum] = useState()
  const [currentPage, setCurrentPage] = useState('All')
  const usePC = useMediaQuery(theme.breakpoints.up('md'))
  const [likeList, setLikeList] = useState(new Array(showContent.length).fill(false))

  useEffect(() => {
    setLikeList(new Array(showContent.length).fill(false))
  }, showContent)

  useEffect(() => {
    const tempReview = []
    const tempForum = []
    data.results.forEach((element) => {
      if (element.category === 'Review') {
        tempReview.push(element)
      } else {
        tempForum.push(element)
      }
    })
    setReview(tempReview)
    setForum(tempForum)
  }, [])

  const handleButtonCategory = (category) => {
    if (category === 'Review') {
      setShowContent(Review)
    } else if (category === 'Forum') {
      setShowContent(Forum)
    } else {
      setShowContent(data.results)
    }
    setPageIndex(1)
    setCurrentPage(category)
    setShow(true)
    setTimeout(() => {
      setShow(false)
    }, 500)
  }

  const checkTimeInterval = (updateTime) => {
    if (curYear - updateTime[0] >= 1) {
      return abMonth[parseInt(updateTime[1]) - 1] + ' ' + updateTime[2] + ', ' + updateTime[0]
    } else if (
      (curMonth - parseInt(updateTime[1]) === 1 && 30 - parseInt(updateTime[2]) + curDay <= 30) ||
      curMonth - parseInt(updateTime[1]) === 0
    ) {
      if (curMonth - parseInt(updateTime[1]) === 1) {
        return 30 - parseInt(updateTime[2]) + curDay + ' days ago'
      } else {
        return curDay - parseInt(updateTime[2]) + ' days ago'
      }
    } else {
      return abMonth[parseInt(updateTime[1]) - 1] + ' ' + updateTime[2] + ', ' + updateTime[0]
    }
  }

  const timer = (info) => {
    setTimeout(function () {
      patchLike(info).then(setTimeInterval(false))
    }, 3000)
  }

  const handleLike = (id, like, i) => {
    const newlist = [...likeList]
    newlist[i] = !newlist[i]
    setLikeList(newlist)
    if (newlist[i]) {
      like += 1
    }
    const result = {
      target_forum_uid: id,
      like: newlist[i]
    }

    if (!timeInterval) {
      setTimeInterval(true)
      timer(result)
    }
  }

  const handleChangePage = (event, value) => {
    document.getElementById('community').scrollIntoView()
    setPageIndex(value)
    setShow(true)
    setTimeout(() => {
      setShow(false)
    }, 1000)
  }

  return (
    <div className={styles['community-wrapper']} id="community">
      <Typography className={styles['community-title']}>{i18n.t(k.VOICE_FROM_ORKA_USERS)}</Typography>
      <Typography className={styles['community-subtitle']}>{i18n.t(k.EVERY_USER_S_OPINION_MATTERS)}</Typography>
      <Trustpilot textAlign="left" sx={{ width: '250px', transform: 'translateX(-11px)', mt: '24px' }} />
      <div style={{ marginTop: '28px', display: 'flex', flexDirection: 'row' }}>
        <div
          className={currentPage === 'All' ? classes.buttonStyleSelected : classes.buttonStyle}
          onClick={() => {
            handleButtonCategory('All')
          }}
        >
          <Typography
            className={classes.buttonText}
            sx={{
              fontWeight: { xs: currentPage === 'All' ? 500 : 400, lg: currentPage === 'All' ? 600 : 400 },
              fontSize: { xs: '16px', lg: '18px' },
              color: currentPage === 'All' ? '#26201F' : '#979797'
            }}
          >
            {i18n.t(k.ALL)}
          </Typography>
        </div>
        <div
          className={currentPage === 'Forum' ? classes.buttonStyleSelected : classes.buttonStyle}
          style={{ marginLeft: usePC ? '24px' : '10px' }}
          onClick={() => {
            handleButtonCategory('Forum')
          }}
        >
          <Typography
            className={classes.buttonText}
            sx={{
              fontWeight: { xs: currentPage === 'Forum' ? 500 : 400, lg: currentPage === 'Forum' ? 600 : 400 },
              fontSize: { xs: '16px', lg: '18px' },
              color: currentPage === 'Forum' ? '#26201F' : '#979797'
            }}
          >
            {i18n.t(k.HEARING_FORUMS)}
          </Typography>
        </div>
        <div
          className={currentPage === 'Review' ? classes.buttonStyleSelected : classes.buttonStyle}
          style={{ marginLeft: usePC ? '24px' : '10px' }}
          onClick={() => {
            handleButtonCategory('Review')
          }}
        >
          <Typography
            className={classes.buttonText}
            sx={{
              fontWeight: { xs: currentPage === 'Review' ? 500 : 400, lg: currentPage === 'Review' ? 600 : 400 },
              fontSize: { xs: '16px', lg: '18px' },
              color: currentPage === 'Review' ? '#26201F' : '#979797'
            }}
          >
            {i18n.t(k.USER_REVIEWS)}
          </Typography>
        </div>
      </div>

      <div className={show ? styles['triggle-forum-content'] : styles['forum-content']}>
        {showContent.slice(pageIndex * 3 - 3, pageIndex * 3).map((v, i) => (
          <div key={i} className={styles['top-forum']} id={`${v.title}`}>
            <img src={'/imgs/ceo/Vector.svg'} className={styles['quote-img']} />
            <Typography className={styles['forum-title']}>{v.title}</Typography>
            <Typography className={styles['time-style']}>
              {checkTimeInterval(v.create_time.slice(0, 10).split('-'))}
            </Typography>
            <Typography className={styles['forum-text']}>{v.story}</Typography>
            <div className={styles['gray-line']} />
            <Typography className={styles['name-style']}>{v.name}</Typography>
            <div
              className={styles['favorite-and-share']}
              onClick={() => handleLike(v.uid, v.like, i + (pageIndex - 1) * 3)}
            >
              <div className={styles['favorite-wrapper']}>
                {likeList[i + (pageIndex - 1) * 3] ? (
                  <FavoriteIcon className={styles['favorite-style-click']} />
                ) : (
                  <FavoriteBorderIcon className={styles['favorite-style']} />
                )}

                <Typography className={styles['favorite-number']}>
                  {likeList[i + (pageIndex - 1) * 3] ? v.like + 1 : v.like}
                </Typography>
              </div>
            </div>
            {v.orka && (
              <div className={styles.comment}>
                <Typography className={styles.commentText}>
                  {/* <p>{v.orka}</p> */}
                  <p>
                    <Markdown>{v.orka}</Markdown>
                  </p>
                  <p>{i18n.t(k.ORKA_TEAM)}</p>
                </Typography>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* </AnimationBlock> */}
      <div className={styles.paginationStyle}>
        <Pagination
          classes={{
            ul: classes.paginationButton
          }}
          count={Math.ceil(showContent.length / 3)}
          shape="rounded"
          onChange={handleChangePage}
          color="secondary"
          variant="contained"
          hideNextButton
          hidePrevButton
          page={pageIndex}
        />
      </div>
    </div>
  )
}

export default Forum
